<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-clipboard-list</v-icon>
        <span class="ml-2 title">Encuestas</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-btn
              color="primary"
              :to="{ name: 'encuestasCrear' }"
            >
              Agregar
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :items="encuestas"
          :headers="headers"
          hide-default-footer
          :items-per-page="rows"
        >
          <template v-slot:item.opciones="{ item }">
            <v-btn
              small
              text
              class="ml-1"
              color="primary"
              @click="editEncuesta(item.id)"
            >
              <v-icon>fas fa-edit</v-icon>
            </v-btn>
            <v-btn
              small
              text
              color="secondary"
              class="ml-1"
              @click="editPreguntas(item.id)"
            >
              <v-icon>fas fa-question</v-icon>
            </v-btn>
            <v-btn
              small
              text
              color="accent"
              class="ml-1"
              @click="$router.push({ name: 'resultados', params: { id: item.id } })"
            >
              <v-icon>fas fa-chart-line</v-icon>
            </v-btn>
            <v-btn
              small
              text
              color="info"
              class="ml-1"
              @click="$router.push({ name: 'graficas', params: { id: item.id } })"
            >
              <v-icon>fas fa-chart-pie</v-icon>
            </v-btn>
            <v-btn
              small
              text
              color="error"
              @click="deleteEncuesta(item.id)"
            >
              <v-icon>fas fa-trash</v-icon>
            </v-btn>

          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogUpdate" max-width="400px">
      <EditEncuesta
        v-model="selected"
        @close="dialogUpdate = false"
        @saved="refresh()"
      ></EditEncuesta>
    </v-dialog>
    <v-dialog v-model="dialogPreguntas" max-width="400px">
      <EditPreguntas
        :encuestaID="encuestaID"
        @close="dialogPreguntas = false"
        @saved="refresh()"
      ></EditPreguntas>
    </v-dialog>
  </v-container>
</template>

<script>
import dayjs from 'dayjs'
import EditEncuesta from '../components/EditEncuesta'
import EditPreguntas from '../components/EditPreguntas'
export default {
  components: {
    EditEncuesta,
    EditPreguntas
  },
  data () {
    return {
      encuestas: [],
      headers: [
        { text: 'Descripcion', value: 'descripcion', sortable: false },
        { text: 'Fecha de inicio', value: 'fechaInicio', sortable: false },
        { text: 'Fecha de fin', value: 'fechaFin', sortable: false },
        { text: 'Opciones', value: 'opciones', sortable: false }
      ],
      dialogUpdate: false,
      dialogPreguntas: false,
      encuestaID: null,
      selected: {
        id: null,
        descripcion: '',
        fecha_inicio: '',
        fecha_fin: ''
      }
    }
  },
  created () {
    this.getEncuestas()
  },
  computed: {
    rows () {
      return this.encuestas.length ? this.encuestas.length + 10 : 25
    }
  },
  methods: {
    async getEncuestas () {
      try {
        const { data } = await this.$http.encuestas.get('?_sort=createdAt:DESC')
        this.encuestas = data.map(i => {
          return {
            ...i,
            fechaInicio: dayjs(i.fecha_inicio).format('DD-MM-YYYY HH:mm'),
            fechaFin: dayjs(i.fecha_fin).format('DD-MM-YYYY HH:mm'),
            fecha_inicio: dayjs(i.fecha_inicio).format('YYYY-MM-DDTHH:mm'),
            fecha_fin: dayjs(i.fecha_fin).format('YYYY-MM-DDTHH:mm')
          }
        })
      } catch (error) {
        window.alert('😅 Ha ocurrido un error')
      }
    },
    async deleteEncuesta (id) {
      if (window.confirm('¿Estas seguro de eliminar el registro?')) {
        const encuesta = this.encuestas.find(i => i.id === id)
        await this.$http.encuestas.delete(`/${encuesta.id}`)
        for (const item of encuesta.preguntas) {
          await this.$http.preguntas.delete(`/${item.id}`)
        }
        this.getEncuestas()
      }
    },
    editEncuesta (id) {
      this.selected = this.encuestas.find(i => i.id === id)
      this.dialogUpdate = true
    },
    editPreguntas (id) {
      this.encuestaID = id
      this.dialogPreguntas = true
    },
    refresh () {
      this.dialogPreguntas = false
      this.dialogUpdate = false
      this.getEncuestas()
    }
  }
}
</script>
